export enum DomEvent {
    ContentLoaded = 'DOMContentLoaded',
    Load = 'load',
    ReadyStateChange = 'readystatechange',
    Resize = 'resize',
    BeforeInstallPrompt = 'beforeinstallprompt',
    DeferredPromptUpdate = 'deferredPromptUpdate',
    PromptA2HS = 'promptA2HS',
    AppInstalled = 'appinstalled',
    Scroll = 'scroll',
    TransitionEnd = 'transitionend',
}
